import React from 'react'
import {Link} from "@reach/router";

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
                <li><Link className="icon alt fa-facebook" to={"//javascript;"}
                          onClick={() => window.open("//www.facebook.com/akshay.joshi4", "_blank")}>
                    <span className="label">Facebook</span>
                </Link></li>

                <li><Link className="icon alt fa-linkedin" to={"//javascript;"}
                          onClick={() => window.open("//www.linkedin.com/in/akshaypjoshi/", "_blank")}>
                    <span className="label">LinkedIn</span>
                </Link></li>

                <li><Link className="icon alt fa-github" to={"//javascript;"}
                          onClick={() => window.open("//github.com/akshaypjoshi", "_blank")}>
                    <span className="label">GitHub</span>
                </Link>
                </li>

                <li><Link className="icon alt fa-stack-overflow" to={"//javascript;"}
                          onClick={() => window.open("//stackoverflow.com/users/7589318/akshaypjoshi", "_blank")}>
                    <span className="label">Stack Overflow</span>
                </Link>
                </li>

                <li><Link className="icon alt fa-twitter" to={"//javascript;"}
                          onClick={() => window.open("//twitter.com/akshaypjoshi", "_blank")}>
                    <span className="label">Twitter</span>
                </Link>
                </li>

                <li><Link className="icon alt fa-instagram" to={"//javascript;"}
                          onClick={() => window.open("//www.instagram.com/akshaypjoshi/", "_blank")}>
                    <span className="label">Instagram</span>
                </Link>
                </li>
            </ul>
            <ul className="copyright">
                <li>&copy; akshaypjoshi</li>
            </ul>
        </div>
    </footer>
)

export default Footer
